import * as constants from '../constants/constants';
import { MEAL_DEFAULT_TIMES } from '../constants/appConstants';
import { sendFilters } from './sendFilters';
import { toastSuccess, toastError } from '../utils/toastMessage';
import errorHandler from '../utils/errorHandler';
import { loaderStart, loaderFinish } from './loader';
import {
  transformMenuStructure,
  countDishValues,
  searchRecurringDaysInCleanMenu,
  transformRecurringMenuStructure,
  searchRecurringDays,
} from './menu';
import { transformMenuForSave } from './menuActions';
import API from '../utils/API';
import generateUniqueId from '../utils/generateUniqueId';

export const changeTemplateName = (templateName) => {
  return {
    type: constants.CHANGE_TEMPLATE_NAME,
    payload: {
      templateName,
    },
  };
};

export const changeTemplateDescription = (templateDescription) => {
  return {
    type: constants.CHANGE_TEMPLATE_DESCRIPTION,
    payload: {
      templateDescription,
    },
  };
};

export const selectTemplateTagsFilters = (templateTagsFilters) => {
  return {
    type: constants.SET_TEMPLATE_TAGS_FILTERS,
    payload: {
      templateTagsFilters,
    },
  };
};

export const setTemplateParametersCategories = (templateParamTagsFilters) => {
  return {
    type: constants.SET_TEMPLATE_PARAMETERS_CATEGORIES,
    payload: {
      templateParamTagsFilters,
    },
  };
};

export const setUserCurrentDay = (currentMenuDay) => {
  return {
    type: constants.SET_USER_CURRENT_DAY,
    payload: {
      currentMenuDay,
    },
  };
};

export const changeTemplateMenuDays = (countDays) => {
  return {
    type: constants.CHANGE_TEMPLATE_MENU_DAYS,
    payload: {
      countDays,
    },
  };
};

export const changeTemplateSameDaysCount = (templateSameDaysCount) => {
  return {
    type: constants.CHANGE_TEMPLATE_SAME_DAYS_COUNT,
    payload: {
      templateSameDaysCount,
    },
  };
};

export const setTemplateDayTabSelect = (number) => {
  return {
    type: constants.SET_TEMPLATE_DAY_TAB,
    payload: {
      number,
    },
  };
};

export const setMenuTemplateGenerator = (menuTemplateGenerator) => {
  return {
    type: constants.SET_MENU_TEMPLATE_GENERATOR,
    payload: {
      menuTemplateGenerator,
    },
  };
};

const checkGeneratedMenu = (generationСheck, template_id) => {
  return (dispatch) => {
    API.get(`/template/${template_id}`).then((result) => {
      toastSuccess('Шаблон успешно сгенерирован');
      dispatch(loaderFinish());
      clearInterval(generationСheck);
      dispatch(setTemplateDayTabSelect(0)); // change selected tab to first
      const transformedMenu = transformMenuStructure(result.data.data.menu);
      dispatch(setMenuTemplateGenerator(transformedMenu));
    });
  };
};

const getMenuForTemplate = () => {
  return (dispatch, getState) => {
    const {
      templateName,
      templateTagsFilters,
      countTemplateDays,
      templateSameDaysCount,
      chosenTemplateEatings,
      templateGenerationWeight,
      templateGenerationCalories,
    } = getState().templateGenerator;
    const { templateDescription } = getState().templateGenerator;
    const { selectedFolderId } = getState().folders;
    const excludeTags = templateTagsFilters.join('|');
    const eatings_tags = chosenTemplateEatings.join('|');
    if (!eatings_tags.length) {
      toastError('Приемы пищи не выбраны.');
      return;
    }
    dispatch(loaderStart());
    // default params for generation
    API.get('/template/create', {
      params: {
        title: templateName,
        days: countTemplateDays,
        numberOfRecurringDays: templateSameDaysCount,
        exclude_tags: excludeTags,
        eating_tags: eatings_tags,
        weight: templateGenerationWeight,
        calories: templateGenerationCalories,
        folder_id: selectedFolderId,
        description: templateDescription,
      },
    })
      .then((resp) => {
        const { template_id } = resp.data.data;
        const generationСheck = setInterval(
          () => dispatch(checkGeneratedMenu(generationСheck, template_id)),
          15000,
        );
      })
      .catch((err) => {
        const errorConfig = {
          400: {
            message: 'Сгенерировать шаблон не удалось',
          },
        };
        dispatch(loaderFinish());
        if (err.response) {
          errorHandler(err.response.status, errorConfig);
        }
      });
  };
};

export const generateTemplateMenu = () => {
  return async (dispatch, getState) => {
    const { templateTagsFilters } = getState().templateGenerator;
    await dispatch(getMenuForTemplate());
    await dispatch(sendFilters(templateTagsFilters));
  };
};

export const setChosenTemplateEatings = (chosenTemplateEatings) => {
  return {
    type: constants.SET_CHOSEN_TEMPLATE_EATINGS,
    payload: {
      chosenTemplateEatings,
    },
  };
};

export const setTemplateGenerationWeight = (templateGenerationWeight) => {
  return {
    type: constants.SET_TEMPLATE_GENERATION_WEIGHT,
    payload: {
      templateGenerationWeight,
    },
  };
};

export const setTemplateGenerationCalories = (templateGenerationCalories) => {
  return {
    type: constants.SET_TEMPLATE_GENERATION_CALORIES,
    payload: {
      templateGenerationCalories,
    },
  };
};

export const setGenderValue = (genderValue) => {
  return {
    type: constants.SET_GENDER_VALUE,
    payload: {
      genderValue,
    },
  };
};

export const resetTemplateData = () => {
  return {
    type: constants.RESET_TEMPLATE_DATA,
  };
};

export const toggleTemplateEating = (eatingId) => {
  return (dispatch, getState) => {
    const { chosenTemplateEatings } = getState().templateGenerator;
    let newChosenTemplateEatings = JSON.parse(JSON.stringify(chosenTemplateEatings));
    if (chosenTemplateEatings.includes(eatingId)) {
      newChosenTemplateEatings = chosenTemplateEatings.filter((tagId) => tagId !== eatingId);
    } else {
      newChosenTemplateEatings.push(eatingId);
    }
    dispatch(setChosenTemplateEatings(newChosenTemplateEatings));
  };
};

export const saveTemplate = () => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    const {
      templateName,
      templateTagsFilters,
      countTemplateDays,
      menuTemplateGenerator,
      chosenTemplateEatings,
      templateDescription,
      templateParametersCategories,
      genderValue,
    } = getState().templateGenerator;
    const { selectedFolderId } = getState().folders;
    const filters = [
      ...chosenTemplateEatings,
      ...templateTagsFilters,
      ...templateParametersCategories,
      genderValue,
    ];
    const dishes = transformMenuForSave(menuTemplateGenerator);
    const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
    const data = {
      dishes,
      days: countTemplateDays,
      filters, // why we save template with filters? - because we can filter templates by tags
      title: templateName,
      folder_id: selectedFolderId,
      numberOfRecurringDays,
    };
    if (templateDescription) data.description = templateDescription;
    API.post('/template', data)
      .then(() => {
        dispatch(loaderFinish());
        toastSuccess('Шаблон успешно сохранен');
      })
      .catch(() => {
        dispatch(loaderFinish());
        toastError();
      });
  };
};

export const changePortion = (newMenu, dish, value) => {
  return (dispatch) => {
    dish.quantity = value;
    countDishValues(dish, 'calories');
    countDishValues(dish, 'proteins');
    countDishValues(dish, 'fats');
    countDishValues(dish, 'carbohydrates');
    dispatch(setMenuTemplateGenerator(newMenu));
  };
};

export const changeDish = (newMenu, newDishData, newDishId, dishData, eating) => {
  return (dispatch) => {
    if (newDishId) {
      dishData.dish = newDishData;
      let { time } = eating.meals[0];
      if (newDishData.name === 'Вода') {
        if (eating.type === 'morning') {
          time = 'Натощак';
        } else {
          time = '+ час';
        }
      }
      dishData.quantity = newDishData.avg_weight;
      dishData.time = time;
      countDishValues(dishData, 'calories');
      countDishValues(dishData, 'proteins');
      countDishValues(dishData, 'fats');
      countDishValues(dishData, 'carbohydrates');
    } else {
      dishData.quantity = 0;
      dishData.time = null;
      dishData.counted_calories = 0;
      dishData.counted_proteins = 0;
      dishData.counted_fats = 0;
      dishData.counted_carbohydrates = 0;
      dishData.dish = null;
    }
    dispatch(setMenuTemplateGenerator(newMenu));
  };
};

export const changeRecurringDay = (
  newMenu,
  newDishData,
  newDishId,
  recurringMeals,
  whatChangeInDay,
  value,
) => {
  return (dispatch, getState) => {
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (dishData.recurringMealsId === recurringMeals) {
            switch (whatChangeInDay) {
              case 'dish':
                dispatch(changeDish(newMenu, newDishData, newDishId, dishData, eating));
                break;
              case 'portion':
                dispatch(changePortion(newMenu, dishData, value));
                break;
              case 'deleteDish':
                eating.meals = eating.meals.filter(
                  (dishData) => dishData.recurringMealsId !== recurringMeals,
                );
                if (eating.meals.length === 0) {
                  const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
                  const transformMenu = transformRecurringMenuStructure(
                    newMenu,
                    numberOfRecurringDays,
                  );
                  dispatch(setMenuTemplateGenerator(transformMenu));
                } else {
                  dispatch(setMenuTemplateGenerator(newMenu));
                }
                break;
              case 'dishTime':
                dishData.time = value;
                dispatch(setMenuTemplateGenerator(newMenu));
                break;
              default:
                break;
            }
          }
        });
      });
    });
  };
};

export const changeTemplateGeneratorDishPortion = (positionDishId, value) => {
  return async (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    const { isChangeTheSameDays } = getState().menu;
    let recurringMeals = '';
    const whatChangeInDay = 'portion';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dish) => {
          if (isChangeTheSameDays && dish.recurringMealsId) {
            if (dish.id === positionDishId) {
              recurringMeals = dish.recurringMealsId;
              dispatch(changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay, value));
            }
          } else if (dish.id === positionDishId) {
            dispatch(changePortion(newMenu, dish, value));
          }
        });
      });
    });
  };
};

export const changeTemplateGeneratorDish = (positionDishId, newDishId) => {
  return (dispatch, getState) => {
    const { dishes } = getState().reducers;
    const { isChangeTheSameDays } = getState().menu;
    const whatChangeInDay = 'dish';
    let recurringMeals = '';
    const newDishData = newDishId ? dishes.find((dish) => dish.id === newDishId) : null;
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(
                changeRecurringDay(
                  newMenu,
                  newDishData,
                  newDishId,
                  recurringMeals,
                  whatChangeInDay,
                ),
              );
            }
          } else if (dishData.id === positionDishId) {
            dispatch(changeDish(newMenu, newDishData, newDishId, dishData, eating));
          }
        });
      });
    });
  };
};

export const addTemplateGeneratorDish = (dayIndex, type) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
    let recurringDays = [];

    if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      newMenu[dayIndex][0].meals.length === 0 &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDaysInCleanMenu(newMenu, dayIndex, type);
    } else if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      newMenu[dayIndex][0].meals[0] &&
      newMenu[dayIndex][0].meals[0].recurringMealsId &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDays(newMenu, dayIndex, type);
    } else {
      recurringDays.push(dayIndex);
    }
    const UniqueId = generateUniqueId();
    for (let i = 0; i < recurringDays.length; i++) {
      newMenu[recurringDays[i]].forEach((eating) => {
        if (!eating.meals) {
          return;
        }
        if (eating.type === type) {
          let time = MEAL_DEFAULT_TIMES[eating.type];
          if (eating.meals.length) time = eating.meals[0].time;
          const emptyDish = {
            id: generateUniqueId(), // generate unique id
            dish: {
              name: null,
              calories: 0,
              carbohydrates: 0,
              fats: 0,
              proteins: 0,
            },
            counted_calories: 0,
            counted_carbohydrates: 0,
            counted_fats: 0,
            counted_proteins: 0,
            quantity: 0,
            time,
            recurringMealsId: UniqueId,
          };
          if (isChangeTheSameDays && eating.meals[0] && +numberOfRecurringDays !== 0) {
            emptyDish.recurringMealsId = eating.meals[0].recurringMealsId + 1 + eating.meals.length; //
          } else if (
            isChangeTheSameDays &&
            eating.recurringCleanMealsId &&
            +numberOfRecurringDays !== 0
          ) {
            emptyDish.recurringMealsId = eating.recurringCleanMealsId + 1 + eating.meals.length;
          } else if (
            isChangeTheSameDays &&
            !eating.recurringCleanMealsId &&
            +numberOfRecurringDays !== 0
          ) {
            // eslint-disable-next-line prefer-template
            emptyDish.recurringMealsId = eating.order + '1' + eating.meals.length;
          }

          const mealWaterIndex = eating.meals.findIndex(
            (dishData) => dishData.dish.name === 'Вода',
          );
          if (mealWaterIndex !== -1) {
            eating.meals.splice(mealWaterIndex, 0, emptyDish); // insert empty dish before water
            dispatch(setMenuTemplateGenerator(newMenu));
            return;
          }
          eating.meals.push(emptyDish);
          dispatch(setMenuTemplateGenerator(newMenu));
        }
      });
    }
  };
};

export const deleteTemplateGeneratorDish = (positionDishId) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
    const whatChangeInDay = 'deleteDish';
    let recurringMeals = '';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId && +numberOfRecurringDays !== 0) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay));
            }
          } else {
            if (dishData.id === positionDishId) {
              eating.meals = eating.meals.filter((dishData) => dishData.id !== positionDishId);
            }
            if (eating.meals.length === 0) {
              const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
              const transformMenu = transformRecurringMenuStructure(newMenu, numberOfRecurringDays);
              dispatch(setMenuTemplateGenerator(transformMenu));
            } else {
              dispatch(setMenuTemplateGenerator(newMenu));
            }
          }
        });
      });
    });
  };
};

export const changeTemplateGeneratorMealTime = (dayIndex, type, timeValue) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
    let recurringDays = [];
    if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      newMenu[dayIndex][0].meals[0] &&
      newMenu[dayIndex][0].meals[0].recurringMealsId &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDays(newMenu, dayIndex, type);
    } else {
      recurringDays.push(dayIndex);
    }
    for (let i = 0; i < recurringDays.length; i++) {
      newMenu[recurringDays[i]].forEach((eating) => {
        if (!eating.meals) {
          return;
        }
        if (eating.type === type) {
          eating.meals.forEach((dishData) => {
            if (dishData.dish.name !== 'Вода') {
              dishData.time = timeValue;
            }
          }); // water exception
          if (eating.meals.length >= 1 && eating.meals[0].dish.name === 'Вода') {
            eating.meals[0].time = timeValue;
          }
          dispatch(setMenuTemplateGenerator(newMenu));
        }
      });
    }
  };
};

export const changeTemplateGeneratorDishTime = (positionDishId, timeValue) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().templateGenerator.menuTemplateGenerator));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().templateGenerator.templateSameDaysCount;
    const whatChangeInDay = 'dishTime';
    let recurringMeals = '';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId && +numberOfRecurringDays !== 0) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(
                changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay, timeValue),
              );
            }
          } else if (dishData.id === positionDishId) {
            dishData.time = timeValue;
            dispatch(setMenuTemplateGenerator(newMenu));
          }
        });
      });
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/templateGenerator.js